const labels = new Map([
  ['sk', { menu: 'Menu', previous: 'Predchádzajúca stránka referencií', next: 'Ďalšia stránka referencií', detail: 'Detail referencie', download: 'Stiahnuť dokument' }],
  ['en', { menu: 'Menu', previous: 'Previous page of references', next: 'Next page of references', detail: 'Reference details', download: 'Download document' }],
  ['de', { menu: 'Menü', previous: 'Vorherige Referenzseite', next: 'Nächste Referenzseite', detail: 'Referenzdetails', download: 'Dokument herunterladen' }],
]);

export const getControlLabels = (locale: string) => labels.get(locale) ?? labels.get('en')!;
